import { useConditionBuilderStoreApi } from '../store';
import { RuleCombinator } from '../types/rule';
import { createEmptyRule } from '../utils';

export function useAddRule() {
  const store = useConditionBuilderStoreApi();

  return (type: RuleCombinator) => {
    store.setState((state) => {
      state.condition.combinator = type;
      state.condition.rules.push(createEmptyRule());
    });
  };
}
